/* eslint-disable */

/*
全局数据列表
代码中的组件都需要复用
数据源从这里取
*/
import React from "react"
import {Row, Col} from "antd"


let obj = {
    title: "又一新产品精彩亮相2023环境应急监测高端论坛（西安）",
    feTitle: "发布日期：2023-4-11",
    imgUrl: "img/new/SamplePictures.png",
    type: 'wechat',
    url: 'https://mp.weixin.qq.com/s/rqCwaqDAhUI8ag5vAPaP9w',
    tip: "2023年4月10日，智慧决策2023环境应急监测高端论坛在西安隆重举行。",
};





















/**
 * 新闻数据
 * 真实数据待接入，按时间倒序排序
 * @type {*[]}
 */

export const NewsDetailDataSource = [
    // {
    //     title: "又一新产品精彩亮相2023环境应急监测高端论坛（西安）",
    //     feTitle: "发布日期：2023-4-11",
    //     imgList: [{title: "", url: "img/new/SamplePictures.png"}],
    //     type: 'wechat',
    //     url: 'https://mp.weixin.qq.com/s/rqCwaqDAhUI8ag5vAPaP9w',
    //     textList: [
    //         "2023年4月10日，智慧决策2023环境应急监测高端论坛在西安隆重举行。",
    //     ],
    // },
    //todo 待接口将上面数据改为动态的

    {
        title: "兰州大学草地农业科技学院李春杰院长一行莅临我司交流访问", feTitle: "发布日期：2023-2-28",
        imgList: [{title: "", url: "img/new/new23.jpg"}],
        textList: [
            "2023年2月24日下午，兰州大学草地农业科技学院李春杰院长一行莅临我司交流访问。",
            <div className="Flex1">
                <img src="img/new/new23.jpg" style={{margin: '0 auto', width: '60%'}} className="wid50"/>
            </div>,
            "李院长一行参观了我司高性能计算中心，详细了解了我司在智慧林草业务领域所做的创新探索与实践，对我司研发的草原生态监测设备、林草图像识别、无人机智能识别和定量遥感等技术给予高度肯定，并探讨了将来可以合作的研究领域。",
            "兰州大学草地农业科技学院是全国顶尖的草原生态研究机构，入选“211”和“985”工程学科建设，入选“双一流”学科建设，拥有我国草业科学领域目前唯一的草种创新与草地农业生态系统全国重点实验室、草地农业生态国际联合研究中心、国家“111”草地农业创新引智基地。",
        ],
    },

    {
        title: "深圳市生态环境局一行来我司考察调研", feTitle: "发布日期：2023-2-20",
        imgList: [{title: "", url: "img/new/new21.jpg"}],
        textList: [
            "2月17日下午，深圳市生态环境局二巡王伟雄、福田管理局局长兼深圳中国环境监测总站技术创新研究院副理事长王伟、福田管理局副局长许茂煜等一行莅临我司考察调研。",
            "考察组一行参观了我司高性能计算中心，详细了解了计算中心的数据资源获取和高性能计算能力及在公司业务中的应用情况。对我司实施的有关省市地区的空气质量预报预警、颗粒物与臭氧协同管控及城市空气质量达标管控等项目实践进行了深入了解。",
            "随后，考察组观摩了我司设备研发中心，现场参观调研了我司最新定型的生态监测设备、无人机巡查智能吊舱等新产品及应用情况，对我司主要产品基于物联网、移动通讯、图像识别、卫星遥感、AI 人工智能等技术在生态环境管理相关领域的应用前景进行了讨论交流。",
            <div className="Flex2">
                <img src="img/new/new22.jpg" style={{margin: '0 auto', width: '60%'}} className="wid50"/>
            </div>,
            "考察组还参观了我司软件研发中心，详细询问和了解了我司大气环境达标管控智慧平台（精灵在线）、水质预警溯源系统、道路源尾气核算及管控应用等新软件产品在全国多省市的应用情况和发展规划。",
            "调研中，考察组对我司高性能计算中心的数据获取、处理分析、大规模计算能力及高水平、跨专业的人才团队情况高度认可，尤其是高度评价了我司多种气象、空气质量、水文水质等行业数值模型及大数据智慧算法等自主模型技术和创新应用能力。此次调研，几位领导高度肯定了我司在环境空气质量预报预警模型应用、生态环境数据分析与生态监测智能设备研发领域的实力与产品布局，并诚邀我司前往深圳福田合作发展。",
            <div className="Flex2">
                <img src="img/new/new21.jpg" style={{margin: '0 auto', width: '100%'}} className="wid50"/>
            </div>,
        ],

    },

    {
        title: "助力西宁打好蓝天保卫战", feTitle: "发布日期：2022-1-15",
        imgList: [{title: "", url: "img/new/SamplePictures.png"}],
        textList: [
            "【编者按】西宁市大气环境网格化监管平台为南京雨后地软环境技术有限公司开发，该平台为助力西宁打好蓝天保卫战发挥了重要作用。以下转自2022年01月13日《青海日报》第1版：头版。",
            "本报西宁讯 （记者 倪晓颖） 2021年，西宁市生态环境局以细颗粒物和臭氧协同控制为主导方向，全力推进大气环境网格化监管，显著提升了西宁市大气污染综合防治的科学性和效益。去年全年，西宁市空气质量优良天数为330天，优良率为90.4%，各项污染物浓度大幅降低，环境空气质量明显改善。",
            "为打好蓝天保卫战，西宁市生态环境局以科技手段为污染防治工作赋能，充分利用“西宁市大气环境网格化监管系统”的污染防控指挥效用，对空气质量状况实施全天候3层级网格化监控，随时精准掌握污染动态与风险趋势。利用行业模型、大数据等多种先进技术手段及时预测并发布污染风险与预警，注重打提前量，减缓污染影响，提高污染风险应对能力及效果。有效使用第三方技术力量，在夏季臭氧防治、采暖季颗粒物专项防控等工作上，积极会商、群策群力、重点突破。同时，充分发挥西宁市生态环境管理3级网格化联动和行政执法一条线功能，以213名网格员为支撑做好末端管控，在污染天气预警应对、精准溯源、保良措施落地、考核压力传导等方面科学施策、精准发力，空气质量改善取得显著成效。",
            <div className="Flex1">
                <img src="img/new/new20.jpg" style={{margin: '0 auto', width: '100%'}} className="wid50"/>
            </div>
        ],
    },
    {
        title: "助力吉木萨尔县打赢大气污染防治攻坚战", feTitle: "发布日期：2021-12-28",
        imgList: [{title: "", url: "img/new/new19.jpg"}],
        textList: [
            "近日，我公司收到了一封来自昌吉回族自治州生态环境局吉木萨尔县分局的感谢信，信中肯定了我公司承建的大气环境网格化监管项目为吉木萨尔县大气污染防治追根溯源、责任下移发挥了重要作用，信中高度赞扬了我公司项目组的专业能力和敬业态度，信中指出，在项目团队的辅助下，吉木萨尔县优良天较同期增加18天，重污染天气较去年同期减少10天，空气质量得到显著改善。",
            "南京雨后地软环境技术有限公司将始终秉承“至诚至善，合作共赢”的价值观，携手客户，集智攻关，为深入打好“十四五”大气污染防治攻坚战砥砺前行。",
            <div className="Flex1">
                <img src="img/new/new18.png" style={{margin: '0 auto'}} className="wid50"/>
            </div>
        ],
    },
    {
        title: "大气污染动态解析与减排评估智慧管理系统顺利通过验收", feTitle: "发布日期：2021-11-26",
        imgList: [{title: "", url: "img/new/new17.png"}],
        textList: [
            "2021年11月25日，广西壮族自治区环境保护科学研究院组织召开了“广西自治区大气污染动态解析与减排评估智慧管理系统建设项目”验收会。与会专家认为该项目技术路线合理、方法先进，智慧管理系统在城市群污染传输核算、重点源贡献评估、城市达标减排测算和污染物协同控制等方面实现了智慧化技术辅助，完成了项目的建设目标与任务，一致同意通过验收。",
            "该项目利用国际先进的空气质量模型和深度学习算法，基于多源大数据，实现大气污染源清单动态更新，提升大气污染风险的预判和提前防控能力；对大气主要污染物实现动态解析，提升大气污染防治的科学性和有效性；对重点源污染排放贡献实现动态评估并进行减排情景模拟，为重污染应急提供高效的辅助决策支持；为城市空气质量达标减排和大气污染物协同控制提供科学管控策略，可全面提升广西自治区的大气污染防控与应对能力。",
            "该项目利用国际先进的空气质量模型和深度学习算法，基于多源大数据，实现大气污染源清单动态更新，提升大气污染风险的预判和提前防控能力；对大气主要污染物实现动态解析，提升大气污染防治的科学性和有效性；对重点源污染排放贡献实现动态评估并进行减排情景模拟，为重污染应急提供高效的辅助决策支持；为城市空气质量达标减排和大气污染物协同控制提供科学管控策略，可全面提升广西自治区的大气污染防控与应对能力。",
            <div className="Flex1">
                <img src="img/new/new17.png" style={{margin: '0 auto'}} className="wid50"/>
            </div>
        ],
    },
    {
        title: "公司受邀参加气溶胶遥感与模拟同化研讨会", feTitle: "发布日期：2020年11月10日",
        imgList: [{title: "", url: "img/new/new16.png"}],
        textList: [
            "2020年11月10日，我公司受邀参加由国防科技大学主办的气溶胶遥感与模拟同化研讨会。会议邀请中国矿业大学、南京信息工程大学、江苏省气象局等单位专家围绕空气污染治理、气溶胶遥感与同化技术等问题进行技术交流。江苏及象生态环境研究院总经理左瑞亭代表公司作了题为“气候生态模型系统及遥感监测在生态环境预测与评估中的应用”的技术报告。报告结合公司近几年在多个城市开展的气候生态环境监测和预报工作，重点交流汇报了气候生态模型系统的耦合预测与评估应用、卫星遥感反演应用及可视化系统平台开发与效果展示，与各单位专家进行了深入技术交流，受到参会代表的广泛关注。",
            <div className="Flex1">
                <img src="img/new/new16.png" style={{margin: '0 auto'}} className="wid50"/>
            </div>
        ],
    },

    {
        title: "我公司受邀参加广西臭氧污染防治技术交流会", feTitle: "2019-11-29",
        imgList: [{url: "img/new/new14.png"}],
        textList: [
            "11月29日我公司受邀参加广西臭氧污染防治技术交流会。会议邀请中国环境科学研究院、成都环科院、香港理工大学等单位专家围绕大气臭氧污染解析、防治等问题进行技术交流。我公司左瑞亭总工作了题为“臭氧污染来源解析及相关应用案例”的技术报告，结合公司近几年在相关城市开展的大气污染源解析工作，重点就臭氧污染解析的特殊性、解析的目标与技术、解析案例等方面，进行了技术交流，受到参会代表的广泛关注，会后与不少单位进行了深入交流。",
            <div style={{display: "flex"}}>

                <img src="img/new/new14.png" style={{width: "38%"}}/>
                <img src="img/new/new13.jpg" style={{width: "38%", marginLeft: "2%"}}/>
                <img src="img/new/new15.png" style={{width: "20%", marginLeft: "2%"}}/>

            </div>
        ]
    },
    {
        title: "“第八师石河子市大气臭氧污染成因分析与源解析服务项目”顺利通过验收", feTitle: "发布日期：2019-11-21",
        imgList: [{title: "", url: "img/new/new12.jpg"}],
        textList: [
            "2019年11月21日，新疆生产建设兵团第八师生态环境局在石河子市组织召开了“第八师石河子市大气臭氧污染成因分析与源解析服务项目”验收会。会议邀请中国环境科学研究院、新疆维吾尔自治区环境监测总站、兵团环境保护科学研究所、石河子市气象局、兰州交通大学等单位的专家组成专家组。",
            "与会专家及代表听取了项目承建单位南京雨后地软环境技术有限公司的汇报，审阅了有关资料，经质疑和讨论，认为该项目技术路线合理，方法先进，结果合理，完成了建设的目标与任务。项目实施单位提供的验收资料规范、齐全。专家组一致同意通过验收。",
            "“第八师石河子市大气臭氧污染成因分析与源解析服务项目”基于石河子市大气污染物历史监测数据、PM2.5和VOCs外场组分监测数据、污染源清单数据，综合利用统计模型、空气质量模型和受体模型等手段掌握石河子市O3和PM2.5污染特征，主要解决臭氧污染特征和形成原因、环境空气VOCs组分解析、细颗粒物和臭氧污染源解析、臭氧与细颗粒物协同控制方案，为制定石河子市空气质量达标规划和重污染天气应急预案提供重要基础和依据。",
            <div className="Flex1">
                <img src="img/new/new11.jpg" className="wid50"/>
                <img src="img/new/new12.jpg" className="wid50"/>
            </div>
        ],
    },
    // 新闻资讯2
    {
        title: "美丽中国·网络媒体生态文明行 聚焦青海生态文明建设", feTitle: "发布日期：2019-11-13",
        imgList: [{title: "", url: "img/news/newsDetail2.jpg"}],
        videoUrl: "",
        textList: [
            '11月13日，"美丽中国·网络媒体生态文明行"采访团走进西宁市，共同探索了解这座高原古城的幸福底色---"西宁蓝"。',

            <div className="Flex1">
                <img src="img/news/newsDetail1.png" className="wid50"/>
                <img src="img/news/newsDetail3.png" className="wid50"/>
            </div>,
            <p className="TextMessage" style={{textAlign: "center"}}>站在西山俯瞰西宁，同一视角2014年与2018年对比，天变得更蓝了（西宁市民王生鹏供图）</p>,
            <p className="TextMessage">
                2019年1月至10月，西宁市城市空气质量优良率为86.1%，空气质量优良率和综合指数排名在全国168个重点城市中位居中等偏上，在西北五省区省会城市中位居前列。这得益于西宁一直坚持绿色发展理念，坚持生态优先，将生态文明建设放在突出位置，扎实推进"高原绿""西宁蓝""河湖清"等六大建设行动，全力守护"西宁蓝"。
            </p>,
            <p className="TextMessage">
                西宁市委、市政府高度重视大气污染治理工作，将其作为一项重大的民生工程和推进生态文明建设的关键举措常抓不懈，按照国家《打赢蓝天保卫战三年行动计划》、《青海省打赢蓝天保卫战三年实施方案》、《西宁市打赢蓝天保卫战三年行动任务分工方案》的具体要求，紧紧围绕空气质量改善为工作核心，在控制污染物排放总量上狠下功夫，实行最严格的管控措施，不断创新观念，全力高效推进
                "西宁蓝"建设行动，切实提高"西宁蓝"对广大市民带来的幸福感和获得感。
            </p>,

            <div className="Flex1">
                <img src="img/news/newsDetail4.jpg" className="wid50"/>
                <img src="img/news/newsDetail2.png" className="wid50"/>
            </div>,

            <p className="TextMessage">
                同时，西宁市将已建立的西宁市网格化环境监管体系和网格化监测监管系统进行了有机结合，网格化监管系统及时将社区、街道、地区微型站数据、建筑工地监测数据和空气质量状况，第一时间向各级网格推送环境监管任务，进一步压实基层网格环境监管，通过网格化监管工作高效运转、上下联动、及时解决一些大气环境污染问题。
                "大气污染防治网格化监测监管系统是在2017年建立，在大气治理工作中原来主要靠人防，现在加强了技防建设以后，监测系统实现24小时监控，在管理上也有章可循、有据可查，起到了促进作用。"西宁市大气污染综合治理工作领导小组办公室负责人刘得守告诉记者，如今将科技手段的综合应用作为冬防助力，空气质量得到了明显改善，空气质量优良率从2013年的60.5%上升至2018年的83.4%，各项污染物浓度均有明显下降。一幅"蓝天白云绕城郭、青山绿水美如画"的绿色发展美好图景，正在西宁大地铺展。
            </p>,
            "来源：光明网  记者：张蕃"
        ],
    },
    // 新闻资讯3
    {
        title: "气象泰斗曾庆存院士莅临雨后地软参观指导并题词", feTitle: "发布日期：2019-10-25",
        imgList: [{title: "", url: "img/new/new1.png"}],
        videoUrl: "",
        textList: [
            "2019年10月25日，中国科学院曾庆存院士到南京雨后地软环境技术有限公司参观指导。公司总经理任杰，副总经理左瑞亭、梁志伟及相关技术骨干参加了汇报。",
            "曾院士了解了我公司在气象、环境、生态领域数据分析应用、数值模式预报预警方面的工作成果和技术突破，为公司未来发展指明了方向并现场欣然挥毫题词“雨后地软 生机盎然 图强发奋 人物风流。",
            "对曾院士的肯定和勉励，公司全体员工深受鼓舞。我们会坚定信念，继续加强自主创新能力建设，不懈进取，在主营业务领域精进战略规划、集智攻关，做到创新、引领、启未来！",
            // <img src="/img/新闻10.jpg" className="guidance" />,
            <div>
                <div className="Flex1 picBorder">
                    <img src="/img/new/new5.jpg" className="wid50"/>
                    <img src="/img/new/new9.jpg" className="wid50"/>
                </div>

                <div className="Flex1 picBorder">
                    <img src="/img/new/new6.jpg" className="wid50"/>
                    <img src="/img/new/new7.jpg" className="wid50"/>
                </div>
                <div className="Flex1 picBorder">
                    <img src="/img/new/new1.png" className="wid86"/>
                </div>

                <div className="Flex1 picBorder">
                    <img src="/img/new/new8.jpg" className="wid50"/>
                    <img src="/img/new/new2.jpg" className="wid50"/>
                </div>
            </div>,
            <h3 style={{
                textIndent: "0",
                fontWeight: "600",
                color: "#3e3a39",
                fontFamily: "Microsoft YaHei"
            }}>曾庆存简介</h3>,
            "曾庆存，男，1935年5月生于广东阳江，1956年北京大学物理系毕业，中国科学院院士，世界科学院院士。曾任中国科学院大气物理研究所所长，中国科学技术协会副主席，中国工业和应用数学学会和中国气象学会理事长。曾先生是国际上推进大气科学和地球流体力学发展成为现代先进科学的著名科学家之一，在国内外享有崇高荣誉。于2016年被世界气象组织授予第61届国际气象组织奖（最高奖）。其主要学术成就和贡献有：1961年首次成功数值求解大气原始方程组作实际数值天气预报；1974年建立大气红外遥感的系统理论和反演方法，是灾害性天气监测和预警的重要手段；1979年开辟大气动力学基题的系统研究，被国际评价为“世界首创”；1999年起开展气候灾害的监测预测和防控及与超算结合研究。目前领导和参与了地球系统模式的设计及研制，是“地球系统数值模拟”大科学装置的创导者。"

        ],

    },

    // 新闻资讯4
    {
        title: "“祁连山国家自然保护区生态环境监测项目”顺利通过验收", feTitle: "发布日期：2019-04-24",
        imgList: [{title: "", url: "img/new/new3.png"}],
        videoUrl: "",
        textList: [

            "2019年4月24日，甘肃省生态环境厅在兰州组织召开“祁连山国家自然保护区生态环境监测项目”验收会。会议邀请了生态环境部卫星应用中心、甘肃省气象局、兰州大学、陕西省生态环境监测中心等单位的行业专家组成专家组，经过专家组评审，认为项目成果达到本项目建设目标，一致同意通过验收。",

            <div className="Flex1">

                <p>
                    本项目利用现有信息技术条件，整合了数据、存储、网络传输和计算资源，优化部署了数据库集群和高性能并行计算集群，建成了甘肃省生态环境遥感监测系统，包括建成全省生态环境数据中心和生态环境遥感监测与评估预警业务应用系统，实现了主要遥感影像数据、地面监测与调查数据、经济社会统计数据、网络生态环境数据等多元数据清洗归库，完成了甘肃省区域生态环境状况和生态系统评价及结果可视化、典型区域生态环境预警评价及结果可视化，为甘肃省生态环境长期监测提供了技术支撑。
                </p>
                <img src="img/new/new3.png" style={{width: "33%", height: "100%", marginLeft: "50px"}}/>
            </div>,
        ],
    },
    // 新闻资讯5
    {
        title: "西宁电视台报道本市大气环境网格化监管系统", feTitle: "发布日期：2019-04-01",
        imgList: [{title: "", url: "img/new/new33.png"}],
        textList: [
            "西宁电视台新闻综合频道对“西宁市大气环境网格化监管系统”做了深入报道。 该系统由我公司承建，依托于高性能并行计算平台支撑，融合了大气环境分析预报机理和大气环境网格化监管机制， 利用科学先进的数值模式技术、同化技术、数据分析技术、GIS技术及计算机相关技术等手段， 实现大气污染预报预警与防控决策的网格化、精细化和智能化应用。系统应用后，将有力提升西宁市大气环境防控与综合治理能力， 为改善环境空气质量发挥科技先锋和专家智囊作用。",
        ],
        videoUrl: "img/video1.mp4",
    },

    {
        title: "青青雨后，与我同行——雨后地软召开2019年新春年会", feTitle: "发布日期：2019-01-18",
        imgList: [{title: "", url: "img/news/newsDetail3.jpg"}],
        videoUrl: "",
        textList: [
            "青青雨后，与我同行——雨后地软2019年新春年会于2019年1月18日在南京丁山宾馆隆重举行，全体员工欢聚一堂，共度联欢。",
            "总经理任杰先生做了工作报告，总结了公司2018年度取得的成绩，明确了公司2019年经营的总体规划。 任总指出，2018年公司先后在广西、云南、海南、新疆、江苏、甘肃、青海、河南等地拓展了项目，合同实现新突破，技术实现新跨越， 品牌得到大提升，团队实现高成长。2019年，公司会秉承“至诚至善，合作共赢”的价值观，进一步夯实技术实力，深耕市场， 以客户为中心，把承接的每个项目打造成精品，并让员工共享公司发展成果。",
            "会上，公司对2018年度的优秀员工、技术创新奖获得者进行了表彰和奖励。各部门员工也带来了形式多样、 让人目不暇接的表演：舞蹈、相声、琴艺、武术等节目，精彩纷呈；穿插着各式各样小游戏和抽奖环节，更是将年会的气氛推向高潮。",
            <div>
                <div className="Flex1">
                    <img src="img/news/newsDetail5.jpg" className="wid50"/>
                    <img src="img/news/newsDetail6.jpg" className="wid50"/>
                </div>

                <div className="Flex1">
                    <img src="img/news/newsDetail7.jpg" className="wid50"/>
                    <img src="img/news/newsDetail8.jpg" className="wid50"/>
                </div>

            </div>,
        ],
    },
    {
        title: "公司入选“创业南京”英才计划", feTitle: "发布日期：2019-01-12",
        imgList: [],
        videoUrl: "",
        textList: [
            "根据《关于建设具有全球影响力创新名城的若干政策措施》（宁委发﹝2018〕1号）和南京市委、市政府关于 推进实施“创业南京”英才计划的若干文件精神，经在线申报、资格认定、技术评审、综合评审、审定公示等环节，我公司总经理任杰先生 入选南京市2018年度“高层次创业人才引进计划”、“创新型企业家培育计划”。",
            "高层次创业人才，主要指符合南京市新兴产业发展和产业转型升级方向，带团队、带技术、带项目在宁创办企业 的行业领军人才。要求引进对象具有硕士以上学位或副高以上职称，拥有独立自主知识产权或掌握核心技术，技术成果达到国际先进 或国内领先水平，具有良好产业化潜力和市场前景。",
            "创新型企业家，主要指既懂科技又懂市场，在相关领域开创技术新路径、商业新模式、产业新质态， 对南京市实施创新驱动发展和经济转型升级起到引领示范作用的企业家。",
            "南京计划从2016年起，用5年时间，重点引进扶持1000名高层次创业人才，重点培育200名创新型企业家， 培育对象创办企业中，新增挂牌上市30家，年销售收入超亿元30家，年纳税额超千万元 10家。对于入选高层次创业人才引进计划 及创新型企业家的，南京市财政将给与150万元的资金扶持，提供5年累计不超过3000万元贷款总额的贴息，提供人才公寓、 最高500平方米创业场所等一系列优惠政策。",
        ],
    },
    {
        title: "“气溶胶激光雷达光学厚度同化对空气质量预报的应用研究项目”顺利通过专家评审", feTitle: "发布日期：2018-12-26",
        imgList: [],
        textList: [
            "2018年12月26日，江苏省环境监测中心在南京组织召开“气溶胶激光雷达光学厚度同化对空气质量预报的应用研究项目”验收会。该项目由我公司承接。会议邀请了南京信息工程大学、江苏省环境科学研究院、南京市环境监测中心、常州市环境监测中心等单位的行业专家组成专家组，经过专家评审，一致同意通过验收。",
            "本项目采用三维变分方法对激光雷达AOD资料进行同化研究，构建了一套与江苏省空气质量预报系统相适应的激光雷达AOD同化系统，解决了激光雷达AOD资料在空气质量预报模拟应用中的关键技术问题，提升了空气质量模拟预报准确性。"
        ]
    },

    {
        title: "“广西大气源清单模型建立及运行项目”顺利通过专家评审", feTitle: "发布日期：2018-12-14",
        imgList: [{url: "img/news/news-14.jpg"}],
        textList: [
            "2018年12月14日，广西壮族自治区环境保护科学研究院组织召开了 “广西大气源清单模型建立及运行项目”验收会。会议邀请国防科技大学、广西气象台等单位的行业专家组成专家组。会上，专家组听取了我公司的项目成果汇报，审阅了技术报告等有关材料，认为项目完成了合同中的建设内容，达到各项指标要求，技术路线合理，方法先进，预报结果可靠。专家组一致同意通过验收。",
            "该项目建成了广西空气质量多模式预报系统，部署了WRF、WRF-Chem、CAMx模式系统，并实现自动化运行。能提供广西未来72小时逐小时的空气质量预报及未来4-7天的趋势预报，重点城市分辨率达到1km，可实x现颗粒物和臭氧的区域解析分类源解析及情景模拟功能。",
            <div className="Flex1">
                <img src="img/news/news-14.jpg" className="wid86"/>
            </div>
        ]
    },
    {
        title: "公司通过高新技术企业认证", feTitle: "发布日期：2018-10-24",
        imgList: [{title: "", url: "img/news/newsDetail1.jpg"}],
        videoUrl: "",
        textList: [
            "2018年10月24日，国家科技部全国高新技术企业认定管理工作领导小组办公室，通过科技部火炬中心官网发布 ——江苏省2018年第一批拟认定高新技术企业名单的公示通知，我公司榜上有名。近日，公司顺利通过公示，被认定为国家高新技术企业。",
            "我公司此次顺利通过国家高新技术企业认定，标志着在专利技术、市场推广、企业内控、研发投入、 经营业绩等方面均达到一定水平高度，符合国家、省市有关部门硬性指标要求，代表我公司综合实力已再上新台阶。 公司将以此为契机，进一步加强技术创新能力及科技成果转化能力，不断创新发展大气、环保及生态领域的预测、 模拟与决策服务技术，引领科技进步，以可持续发展理念实现客户目标！",
        ],
    },
    {
        title: "“西宁市大气污染防治城市扬尘精细化监测监管项目”顺利通过验收", feTitle: "发布日期：2018-11-16",
        imgList: [{url: "img/news/news-12-01.jpg"}],
        textList: [
            "2018年11月16日，西宁市环境保护局组织召开了“西宁市大气污染防治城市扬尘精细化监测监管项目”验收会。青海省环保厅、市发改委、市财政局、市大气办、市环保局相关处室代表参加评审。此项目由我公司承建。与会专家及代表听取了我公司的汇报，审阅了有关资料，现场测试了高性能计算集群、抽查了扬尘监测微型站的安装试运行情况，并观看了西宁市大气环境网格化监管业务系统试运行效果演示，认为该项目完成了建设的目标、任务，达到技术要求，试运行结果可靠，一致同意通过验收。",

            "“西宁市大气环境网格化监管系统”是基于西宁市大气环境综合管理需求，为落实大气污染防治措施，改善环境空气质量等提供技术支持的多功能一体化平台。该系统综合集成了环境空气质量实况监测数据展示与分析、气象数值预报、精细化环境空气质量数值预报预警、智能化大气污染源解析、基于“一张图”环保执法与大气环境网格化监管辅助决策等专业模块。",

            "该系统平台的运行依托于高性能并行计算平台支撑，融合了大气环境分析预报机理和大气环境网格化监管机制，利用科学先进的数值模式技术、同化技术、数据分析技术、GIS技术及计算机相关技术等手段，实现大气污染预报预警与防控决策的网格化、精细化和智能化应用。",
            "未来，该平台将充分利用和发挥好现有建设成果，提供客观科学的大气污染防治辅助决策技术支持，不断完善和匹配大气环境网格化监管机制，依靠技术进步全面提升西宁市大气环境防控与综合治理能力，为改善环境空气质量发挥科技先锋和专家智囊作用。",
            <div className="Flex1">
                <img src="img/news/news-12-01.jpg" className="wid50"/>
                <img src="img/news/news-12-02.jpg" className="wid50"/>
            </div>
        ]
    },
    {
        title: "我司受邀参加“2018中国生态环保大会暨第三届绿色发展论坛”", feTitle: "发布日期：2018-07-19",
        imgList: [{url: "img/news/news-09.jpg"}],
        textList: [
            "我司总工左瑞亭受邀参加了此次论坛，并发表题为“网格化监管与大气污染防治精准发力——以西宁市大气污染防治城市扬尘监测监管项目为例”的演讲，从大气环境的准确预报与污染解析、网格化监管与精准治污、大气环境辅助决策管理三方面详细介绍了西宁市大气污染防治城市扬尘监测监管项目，为创新环境监管模式提供了参考。",
            "我司总工左瑞亭受邀参加了此次论坛，并发表题为“网格化监管与大气污染防治精准发力——以西宁市大气污染防治城市扬尘监测监管项目为例”的演讲，从大气环境的准确预报与污染解析、网格化监管与精准治污、大气环境辅助决策管理三方面详细介绍了西宁市大气污染防治城市扬尘监测监管项目，为创新环境监管模式提供了参考。",
            <div className="Flex1">
                <img src="img/news/news-09.jpg" className="wid86"/>
            </div>
        ]
    },
    {
        title: "“园区地块清单和土壤环境管理信息平台构建项目”顺利通过专家技术验收", feTitle: "2018-07-20",
        imgList: [{url: "img/news/news-10.png"}],
        textList: [
            "2018年7月20日，格尔木环保局在西宁市组织召开“格尔木市昆仑经济技术开发区2016年重金属污染防治园区地块清单和土壤环境管理信息平台构建项目”技术评审会，会议邀请中国环科院、北京环科院等单位5名专家组成专家组。参加会议的有海西州环保局、格尔木市环保局、格尔木市昆仑经济技术开发区管委会的代表。与会专家与代表听取了项目承担单位的汇报，认为本项目成果技术资料详实，技术成果完整，相关技术方法和技术内容满足项目要求，可以作为园区后续环境管理的依据。专家组一致同意通过技术评审验收。",
            <div className="Flex1 ">
                <img src="img/news/news-10.png" className="wid86"/>
            </div>
        ]
    },
    {
        title: "“海南省重点石化企业大气污染物排放特征及清单编制项目”顺利通过验收", feTitle: "发布日期：2018-06-14",
        textList: [
            "2018年6月14日，由海南省环境科学研究院主持，在海南省环境科学研究院会议室召开了“海南省重点石化企业大气污染物排放特征及清单编制”项目验收会议。与会专家认真听取了我单位关于项目实施过程及成果的介绍，查阅了项目相关材料，观看了现场成果展示，经过充分讨论，认为该项目成果资料齐全、报告细致，高水平完成项目要求与任务。一致同意通过验收。该项目以石化行业为例，结合海南省排污许可管理要求，通过实际调查、监测与分析，客观科学掌握海南省重点石化企业大气污染排放状况及特征，并提出管控措施，满足管理部门对企业的精细化全过程环境管理的需要。"
        ]
    },
    {
        title: "我司受邀参加“环境健康和环境风险分析评估模拟”培训", feTitle: "发布日期:2018-06-05",
        imgList: [{url: "img/news/news-07.png"}],
        textList: [
            "2018年6月5日至6月6日，由中国环境监测总站组织的环境健康和环境风险分析评估模拟培训班在南京大学顺利举办，来自各省（直辖市、自治区）环境监测中心（站）、新疆生产建设兵团环境监测中心站、河北省环境应急与重污染天气预警中心、山东省环境信息与监控中心相关人员参加了此次培训。",
            "我司作为受邀单位参与了此次培训。公司总工左瑞亭担任本次培训课程《大气环境中的数据分析与数值模式应用技术》的讲师。左总通过ppt展示、案例剖析等方式，深入浅出的介绍了我公司大气环境数据分析、大气环境数值模式应用及预报模型集成技术，现场反响热烈。",
            <div className="Flex1 ">
                <img src="img/news/news-07.png" className="wid86"/>
            </div>
        ]

    },
    {
        title: "CAMx模式部署技术服务项目顺利通过专家组验收", feTitle: "发布日期：2018-09-22",
        textList: [
            "2017年9月22日，由云南省环境监测中心站主持，在云南省环境监测中心站召开 “云南省省级环境空气质量预报预警平台建设（二期）建设”项目验收会议。我公司承接的CAMx模式部署技术服务项目顺利通过专家组验收。"
        ]
    },
    {
        title: "雨后地软获“突发环境事件应急保障数值模拟系统”软件著作权证书",
        imgList: [{url: "/img/rz.jpg"}],
        textList: [
            "",
            <div className="elasticity">
                <div>
                    <p>
                        日前，由雨后地软自主开发的“工业园区突发环境事件应急保障（污染物扩散）数值模拟系统V1.0”顺利通过中国版权保护中心审核，获得国家版权局颁发的计算机软件著作权登记证书。这是雨后地软在环境保护数值模拟领域取得的又一成果。
                    </p>
                    <p>
                        工业园区突发环境事件应急保障（污染物扩散）数值模拟系统V1.0”主要基于区域范围内地理特征、水文情况、天气气候、大气环境（污染）等综合信息，对辖区范围内突发环境事件采取的应急行动提供气象条件等各种要素信息的查询和决策方案；还能结合园区排放清单对污染来源进行解析，实时预报、追踪污染物污染扩散路径、沉降路径。日常管理情况下，该系统通过解析主要污染物对园区大气污染的贡献，预报预警，提供定量预报服务并辅助主管部门制订决策方案，为园区精细化管理提供技术支撑服务。
                    </p>
                </div>
                <div>
                    <img src="/img/rz.jpg" className="wid50"/>
                </div>
            </div>

        ]
    },
    {
        title: "两项发明专利获国家知识产权局受理",
        imgList: [{url: "img/zl_1.png"}],
        textList: [
            "近日，雨后地软申报的“一种将气候模式和化学模式相耦合的分析方法”、 “一种气候-生态系统耦合建模方法”两项发明专利已获国家知识产权局受理，有望在气象、环境、生态行业领域数值模拟方面发挥重要作用。",
            "“一种将气候模式和化学模式相耦合的分析方法” 是以区域气候模式REMO为主体气象模式，嵌入RACM，RADM2和ReLACS等多个化学机制，以FAST-J方案在线计算光化学反应速率，解决了传统气候模式在化学模块的处理上粗略的问题，实现了气候模式与化学模式的耦合，并首次将CHEMEQ2运用于大气科学领域的常微分方程求解，为气溶胶气候效应及大气化学与气候相互作用的研究提供了手段。",
            "“一种气候-生态系统耦合建模方法”基于大数据分析技术和行业数值模拟技术，科学揭示目标区域气候与生态系统的相互作用及反馈关系，实现该地区气候生态系统的客观数值模拟和预测预警服务。",
            "截至目前，雨后地软已获8项专利、5项软件著作权，另有6项专利已由国家知识产权局受理。",
            <div className="Flex1">
                <img src="img/zl_1.png" className="wid50"/>
                <img src="img/zl_2.png" className="wid50"/>
            </div>
        ]
    },
    {
        title: "雨后地软荣获AAA级资信等级证书",
        imgList: [{url: "/img/zx.png"}],
        textList: [
            "近日，雨后地软通过了江苏信诚资信评估有限公司认可，获得3A级资信等级证书。",
            "参照国际惯例，企业资信等级一等资信状况包括三个资信级别，即AAA级、AA级和A级。AAA级资信等级，表示企业经营处于良性循环状态，资产质量优良，经营业绩好，支付能力很强，信誉极好，清偿能力非常强，风险最小，是资信等级中的最高级别。",
            "本次获评最高等级资信是对雨后地软发展前景以及企业信用的客观赞誉和肯定。",
            <div className="Flex1 ">
                <img src="img/zx.png" className="wid86"/>
            </div>
        ]
    },
    {
        title: "雨后地软顺利通过“双软认证”",
        imgList: [{url: "img/1-04.jpg"}],
        textList: [
            "近日，南京雨后地软环境技术有限公司顺利通过“双软认证”。“双软认证”是指软件企业的认定和软件产品的登记。企业申请双软认证，要求拥有核心关键技术，主营业务拥有自主知识产权产品，并对职工学历、研发费用、生产经营场所等多方面有着高标准的要求。雨后地软通过认证，将促进公司研发创新工作再上新台阶。",
            <div className="Flex1">
                <img src="img/1-04.jpg" className="wid50"/>
                <img src="img/1-07.jpg" className="wid50"/>
            </div>
        ]
    },
    {
        title: "雨后地软与知名高校、科研院所达成产学研合作协议",
        textList: [
            "近日，雨后地软与“南京信息工程大学”、“中国科学院大气物理研究所”等知名高校、科研院所签订了产学研框架协议。围绕生态环境数据分析、数值模拟等领域建立全面的产学研合作。"
        ]
    },
    {
        title: "公司获 “江苏省民营科技企业”称号",
        imgList: [{url: "img/news/news-11.jpg"}],
        textList: [
            "近日，经江苏省民营科技企业协会审查和认证，我公司获 “江苏省民营科技企业”称号。",
            <div className="Flex1 ">
                <img src="img/news/news-11.jpg" className="wid86"/>
            </div>
        ]
    },
    {
        title: "公司顺利入库“科技型中小企业”",
        imgList: [],
        textList: [
            "近日，由江苏省科学技术厅发布的《江苏省科技厅关于2018年入库科技型中小企业的公告》中，我司名列其中，（入库登记编号 2018320106A0014402），并且顺利通过公示。"
        ]
    },


];


// coreBusuness.js

export const BusinessDataSource = {
    '大气污染防治"一市一策"': {
        title: "大气污染防治“一市一策”技术支持与辅助决策",
        conList: [
            {
                textList: [
                    <div>
                        <p className="retract ">
                            公司专家组借助当前主流大气模型及公司自主研发成果，通过深入一线、驻点指导的工作方式，基于以下七项决策环节，开展大气环境数据分析、污染来源解析、源清单编制、环境应急、重污染天气应对、污染源治理、达标规划、管理决策等研究，提出“一市一策”的大气污染综合解决方案，精准施策，对症下药，提升城市空气质量达标率。
                        </p>
                    </div>
                ]
            },
            // 大气污染防治"一市一策" 技术支持和辅助决策
            {
                textList: [
                    < img src="img/juece.png" style={{width: "100%"}}/>
                ]
            }
        ]
    },

    "大气环境数据分析与应用": {
        title: "大气环境数据分析与应用",
        conList: [
            {
                pName: "产品介绍",
                textList: [
                    <div className="elasticity ">
                        <div style={{marginTop: "10px"}}>
                            <p className="retract ">
                                应用数值模式、统计学、机器学习等算法工具和GIS等技术，对环境、气象、生态数据时空、时频特征分析，有针对性说明细颗粒物和臭氧等污染成因、变化规律和形成机制，指导拟定大气污染防治措施。
                            </p>

                        </div>
                        <div>
                            <img src="img/certificate.png" className="certificate"/>
                        </div>
                    </div>
                ],
            },
            {
                pName: "服务案例",
                textList: [
                    <div style={{
                        border: "1px solid #000",
                        marginTop: "30px",
                        width: "90%",
                        marginLeft: "5%",
                        padding: "20px 10px"
                    }}>
                        <div><img src="img/AirData.png" className="analyze"/></div>
                        <div>
                            <Row className="Flex1">
                                <Col span={12} style={{paddingLeft: "10px"}} className="rowCol">
                                    <p>贺州市2018年大气环境污染状况分析</p>
                                    <p>信阳市2017年度空气质量状况分析</p>
                                    <p>吉安市2017年度空气质量状况分析</p>
                                    <p>海南省重点石化企业大气污染物排放特征及清单编制</p>
                                </Col>

                                <Col span={11} className="rowCol">
                                    <p>广西北部湾沿海三市大气环境容量评估</p>
                                    <p>西宁市大气环境网格化辅助决策重点区域专题报告</p>
                                    <p>新疆地区2017年春夏季臭氧污染分析报告</p>
                                    <p>江苏省环境监测中心气溶胶聚光雷达光学厚度对空气质量预报的应用研究</p>
                                </Col>
                            </Row>
                        </div>
                    </div>
                ],
            },

        ],
    },

    "大气污染源耦合解析": {
        title: "大气污染源耦合解析",
        conList: [
            {
                pName: "产品介绍",
                textList: [
                    <div>
                        <p className="retract ">
                            采用多种受体模型和空气质量模型，建立大气污染源耦合解析策略，兼顾污染排放源受体环境的实况监测以及大气化学传输模式的物理化学机理优势，抑制传统CMB颗粒物解析法存在的共线性问题、受体模型的二次排放不适用问题以及空气质量模型解析结果不便管控等问题，最终确定污染源高影响区域、高影响行业颗粒物组分、臭氧污染控制型以及高贡献排放源体
                            ,
                            精准确定污染成因，确定主要污染物来源行业和区采用多种受体模型和空气质量模型，建立大气污染源耦合解析策略，兼顾污染排放源受体环境的实况监测以及大气化学传输模式的物理化学机理优势，抑制传统CMB颗粒物解析法存在的共线性问题、受体模型的二次排放不适用问题以及空气质量模型解析结果不便管控等问题，最终确定污染源高影响区域、高影响行业颗粒物组分、臭氧污染控制型以及高贡献排放源体
                            , 精准确定污染成因，确定主要污染物来源行业和区域，指导污染治理。域，指导污染治理。
                        </p>
                    </div>
                ],
                imgList: [],
            },
            {
                pName: "服务案例",
                textList: [],
            },

            {
                textList: [
                    <div>

                        <p className="titleBar">第八师石河子市臭氧污染成因分析与源解析服务</p>
                        <div className="elasticity">
                            <Row>
                                <Col span={12}>
                                    <p className="retract">
                                        基于石河子市大气污染物历史监测数据、PM2.5和VOCs外场组分监测数据、污染源清单数据，综合利用统计模型、空气质量模型和受体模型等手段掌握石河子市O3和PM2.5污染特征，主要解决臭氧污染特征和形成原因、环境空气VOCs组分解析、细颗粒物和臭氧污染源解析、臭氧与细颗粒物协同控制方案，为制定石河子市空气质量达标规划和重污染天气应急预案提供重要基础和依据。
                                    </p>
                                </Col>
                                <Col span={10} offset={1}>
                                    <img src="img/CouplingAnalytical2.png" className="coupling"/>
                                </Col>
                            </Row>
                        </div>
                    </div>
                ],

            },
            {
                textList: [
                    <div>
                        <p className="titleBar">某省会城市NOx、O3 来源解析项目</p>
                        <p className="retract ">
                            充分利用某市现有业务系统资源，采用多重技术方法，对大气NOx、臭氧和PM2.5进行来源解析，定量分析污染来源，明确本地与外来传输对NOx、臭氧和PM2.5污染形成的贡献，判断臭氧污染控制类型，分析对臭氧污染形成贡献显著的VOCs种类并进行来源解析，分析掌握颗粒物与臭氧污染的协同影响关系，通过情景模拟分析等手段，为某市制定科学可行的臭氧与颗粒物污染协同控制减排方案提供理论依据和技术支撑。
                        </p>
                        <img src="img/CouplingAnalytical1.png" style={{width: "100%", marginTop: "50px"}}/>
                    </div>
                ],
            },
        ],
    },


    "大气环境容量测算与达标规划": {
        title: "大气环境容量测算与达标规划",
        conList: [
            {
                pName: "产品服务",
                textList: [
                    <div>
                        <p className="retract ">
                            采用多源数据综合分析技术研判区域大气污染主要问题；运用空气质量模型模拟主要污染物敏感性（HDDM），结合数值模拟与现场监测解析大气污染成因和主要污染物来源行业与区域；测算区域主要污染物环境容量，模拟评估主要减排情景达标效果；制定减排策略，规划分阶段实现空气质量达标的对策措施方案。
                        </p>
                    </div>],
                imgList: [],
            },
            {
                pName: "技术路线",
                textList: [
                    <div>
                        <div>
                            <img src="img/AtmosphericCapacity1.png" className="capacity"/>
                            <p className="textLine">大气环境阶段达标解决方案</p>
                        </div>
                        <div>
                            <img src="img/AtmosphericCapacity2.png" className="capacity"/>
                            <p className="textLine">大气环境达标规划解决方案</p>
                        </div>
                    </div>
                ],
            },

        ],
    },

    "空气质量预报预警与应用": {
        title: "空气质量预报预警与应用",
        conList: [
            {
                pName: "产品服务",
            },
            {
                textList: [
                    <div style={{display: "flex", padding: "30px", background: "#f3f4f6"}}>

                        <div>
                            <p className="retract">
                                基于高性能计算集群HPC，集成搭建WRF-Chem/CAMx/CMAQ/FLEXPART等空气质量多模式预报系统和机器学习、统计预报系统，应用监测站污染数据同化、激光雷达污染同化等技术，基于GIS
                                可视化平台，同步实现大气环境精细化预报预警、首污动态源解析与溯源等功能。
                            </p>
                        </div>

                        <div className="elasticity ">
                            <img src="img/certificate1.png" className="certificate2"/>
                            <img src="img/certificate2.png" className="certificate2"/>
                        </div>
                    </div>
                ]
            },
            {
                textList: [
                    <div>
                        <ul className="forecast">
                            <li>
                                空气质量多模式动力集合短期预报系统。基于SVM支持向量机机器学习技术，智能优化和集成WRF-Chem、CAMx和CMAQ等多模式数值预报结果，实现3-5天短期高时空分辨空气质量污染等级和主要污染浓度的精细化预报。
                            </li>
                            <li>
                                空气质量多模式统计建模趋势预报系统。采用贝叶斯算法优化集成基于神经网络BPNN、集合经验模态分解EEMD以及非线性回归建模等智能建模技术，实现7-15天中长期空气质量的趋势预报。
                            </li>
                            <li>源排放与初值处理系统。基于SMOKE模型和GSI数据同化技术，提供高精度排放源清单和基于地面监测站数据的大气污染初值。</li>
                            <li>
                                污染物轨迹溯源系统。利用高精度WRF模式气象模拟预报数据驱动FLXEPART轨迹溯源模型，实现污染物的长距离跨境传输模拟与轨迹溯源。
                            </li>
                        </ul>
                    </div>
                ]
            },
            {
                pName: "服务案例"
            },
            {
                textList: [
                    <div style={{padding: "0 20px"}}>
                        <div style={{display: "flex"}}>
                            <Row>
                                <Col span={11}>
                                    <div>
                                        < img src="img/XNforecast.png" className="businessPlatform"/>
                                        <p className="textLine2">西宁市大气质量预报预警业务平台</p>
                                    </div>
                                </Col>
                                <Col span={11} offset={1}>
                                    <div>
                                        < img src="img/YN.png" className="businessPlatform"/>
                                        <p className="textLine2">云南省省级环境空气质量预报预警业务平台</p>
                                    </div>
                                </Col>
                            </Row>

                        </div>

                        <div>
                            <img src="img/threeDimensional.png" style={{width: "99%"}}/>
                            <p className="textLine2">三维渲染可视化</p>
                        </div>
                    </div>
                ],
            },
        ],
    },


    "大气环境网格化监管与重污染天气应对": {
        title: "大气环境网格化监管与重污染天气应对",
        conList: [
            {
                pName: "产品介绍",
                textList: [
                    <div style={{display: "flex", padding: "30px", background: "#f3f4f6"}}>

                        <Row>
                            <Col span={16}>
                                <p className="retract ">
                                    基于高密度大气环境监测网、高性能计算平台HPC和大气环境预报预警与溯源解析系统，构建大气环境网格监管辅助决策系统，通过WebGIS和APP应用，将每日环境监测、预报和解析结果自动应用于网格化管控，实现高影响网格锁定、管控任务生成、逐级分解执行、反馈评价、考核记录等全程自动化运行，实现污染防控的网格化、精细化和智能化应用。
                                </p>
                            </Col>
                            <Col span={4} offset={2}>
                                <img src="img/certificate1.png" className="gridding"/>
                            </Col>
                        </Row>

                    </div>
                ],
            },
            {
                textList: [
                    <div>
                        <img src="img/business/business11.png" className="gridding"/>
                        <p className="textLine2">行政化网络监管机制与大气环境机理的数值网格分析技术相组合</p>
                        <img src="img/business/business12.png" className="gridding"/>
                        <p className="textLine2">大气环境网格化监管系统————网格监管任务管理</p>
                        <img src="img/business/business19.png" className="gridding"/>
                        <p className="textLine2">监管网格1公里高分辨大气环境查询</p>
                    </div>
                ]
            }
        ],
    },


    "水文水质评价分析": {
        title: "水文水质评价分析",
        conList: [
            {
                textList: [
                    <div>
                        <p className="retract ">
                            基于水质基本信息与监测数据，对地表水和水功能区水质进行常规评价，整理制作地表水和水功能区等评价对象基本信息和历史水质监测数据，定制开发水质数据报告、通报、公报、常用报表等，开发地表水和水功能区等水质评价个性化功能。
                        </p>
                    </div>
                ],
            },
            {
                textList: [
                    <div className="hydrology">
                        <img src="img/hydrology.png" style={{width: "101%"}}/>
                        <img src="img/waterQuality.png" style={{width: "100%"}}/>
                        <div>
                            <Row>
                                <Col span={6} style={{textAlign: "center"}}>流域原始DEM图</Col>
                                <Col span={6} style={{textAlign: "center"}}>流域填洼后的DEM图</Col>
                                <Col span={6} style={{textAlign: "center"}}>流域水流方向计算成果图</Col>
                                <Col span={6} style={{textAlign: "center"}}>流域坡度计算成果图</Col>
                            </Row>
                        </div>
                    </div>
                ]
            }
        ]
    },


    "水质预报预警": {
        title: "水质预报预警",
        conList: [
            {
                textList: [
                    <div>
                        <p className="retract ">
                            雨后地软水质预报预警系统，综合运用“5s”技术（遥感技术、地理信息系统技术、全球定位系统技术、专家系统、三维分析可视化技术），对地形地貌、水质状况、生态环境、水资源分布等各种信息进行数字化采集与存储，实施动态监测，三维模拟水环境，最后形成集监测、数值模拟、三维可视化与辅助决策为一体的系统，实现地表水在真实3D环境中与模型互动，同时优化OpenGL图形以改进硬件渲染，创建更加逼真的预报预警效果图。
                        </p>
                        <img src="img/business/business20.png" style={{width: "100%", marginTop: "50px"}}/>
                    </div>
                ]
            },
        ],
    },


    "水污染事故溯源": {
        title: "水污染事故溯源",
        conList: [
            {
                textList: [
                    <div>
                        <p className="retract ">
                            与河海大学等国内高校院所联合开发水污染溯源系统，根据观测站实测数据与模拟数据的相关关系构造优化函数，以水文水动力模型为基础，采用改进后微分进化对源项未知参数优化模型进行求解，确定突发性水污染事故的发生时间、位置及污染物质量。进而制定出应对突发性水污染事故应急措施的有效方案，采取各种针对性的补救措施，将事故造成的损失降到最低，为政府相关部门的辅助决策提供强有力的支撑。
                        </p>
                        <img src="img/business/business21.png" style={{width: "100%", marginTop: "50px"}}/>
                    </div>
                ]
            }
        ]
    },
    "危险天气预报预警系统展示": {
        title: "危险天气预报预警系统展示",
        conList: [
            {
                textList: [
                    <div style={{marginLeft: "30px"}}>
                        <img src="img/business/business22.png" style={{width: "100%"}}/>
                        {/*  <div >
                            <Row>
                                <Col span={10} >
                                    <h3 style={{ fontSize: "20px", lineHeight: "40px" }}>危险天气：</h3>
                                    <p style={{ lineHeight: "40px" }}>
                                        暴雨、暴雪、雷暴、大风、冰雹、飑线、龙卷等强对流天气系统,下击暴流、垂直风切变、小尺度旋风等局地灾害风场
                                </p>
                                    <h3 style={{ fontSize: "20px", marginTop: "80px", lineHeight: "40px" }}>
                                        短时危险天气监测系统（监测分析）
                                </h3>
                                    <p style={{ lineHeight: "40px" }}>
                                        <span className="fontW" >危险天气系统特点：</span>

                                        空间和时间尺度都较小，生命史短，发展和消亡迅速，对其的监测在空间和时间上都要提高分辨率 <br />

                                        <span className="fontW" >基本监测平台：</span>
                                        利用多普勒天气雷达和风廓线雷达建立监测网和平台，对未来6小时内的危险天气系统进行监测、分析并外推 <br />

                                        <span className="fontW" >功能：</span>解决6小时内的短时监测和预报问题
                                </p>
                                </Col>
                                <Col span={11} offset={3}>
                                    <h3 style={{ fontSize: "20px", lineHeight: "40px" }}>高分辨非静力数值天气预报系统（动力模式预报）</h3>
                                    <p style={{ lineHeight: "40px" }}>
                                        <span className="fontW" >系统特点：</span>高分辨（1-3km） ,非静力（捕捉强对流） , 物理机制完备<br />
                                        <span className="fontW" >系统构建：</span>高分辨中尺度天气预报数值模式+同化系统<br />
                                        <span className="fontW" >技术特色：</span>采用3维或4维同化系统，吸收雷达、风廓线等非常规高分辨资料<br />
                                        <span className="fontW" >功能：</span>实现未来72小时的天气预报，产品丰富
                                </p>
                                    <h3 style={{ fontSize: "20px", lineHeight: "40px" }}>危险天气分析系统（统计诊断分析）</h3>
                                    <p style={{ lineHeight: "40px" }}>
                                        <span className="fontW" >技术原理：</span>基于气象要素对危险天气现象建立判别机制，在对气象要素进行模式预报的基础上，对危险天气现象进行统计诊断预报并做预报评估<br />
                                        <span className="fontW" >技术特色：</span>方法灵活多样、数理基础强、符合应用需求 <br />
                                        <span className="fontW" >功能：</span>解决6小时内的短时监测和预报问题
                                </p>
                                </Col>
                            </Row>
                        </div>*/}
                        <img src="img/business/business32.png" style={{width: "90%"}}/>
                    </div>
                ]
            }

        ]
    },

    "生态环境监测评价": {
        title: "生态环境监测评价",
        conList: [
            {
                textList: [
                    <div>
                        <p className="retract ">
                            基于卫星遥感、样方监测、模式计算等多源生态环境数据，采用生态学、环境学、系统科学等理论和方法，对生态环境的构成、功能、过程、敏感性、稳定性、脆弱性、潜力与制约因素、不同政策措施的影响及发展趋势等特征，进行GIS分析和景观分析等专题评价，并以时变趋势图、栅格图、等值图、空间2D/3D分布图及动态粒子流等形式实现多维度可视化展示。
                        </p>


                        <div style={{display: "flex", marginTop: "50px"}}>
                            <Row>
                                <Col span={10}>
                                    <img src="img/business/business23.png" style={{width: "83%"}}/>
                                </Col>
                                <Col span={10}>
                                    <div>
                                        <img src="img/business/business24.png" style={{width: "136%"}}/>
                                        <p className="textLine2">
                                            生态功能评估与展示
                                        </p>
                                    </div>
                                </Col>
                            </Row>

                        </div>

                        <div>
                            <img src="img/business/business26.png" style={{marginLeft: "-1%", width: "102%"}}/>
                            <p className="textLine2">
                                遥感解译分析与展示
                            </p>
                        </div>
                    </div>
                ]
            }
        ]
    },

    "气象服务及灾害预报预警": {
        title: "气象服务及灾害预报预警",
        conList: [
            {
                pName: "产品介绍",
                textList: [
                    <div>
                        <div className="elasticity ">
                            <p className="retract ">
                                采用国际先进的气候数值模型、陆面生态模型、生物排放模型等（CESM、RegCM、CLM、MEGAN），基于高性能计算平台HPC和WebGIS框架，搭建气候-陆面-生态耦合数值预测模拟系统，建立区域气候-生态耦合数值模拟及预测预警平台，实现区域尺度短、中、长期气候生态环境的演变趋势预测预警，实现气候环境与生态相互作用反馈的评估分析与情景模拟，为生态环境保护决策提供科学客观、定量可靠的技术支持。
                            </p>
                            <div>
                                <img src="img/certificate3.png" className="certificate"/>
                            </div>
                        </div>
                    </div>
                ]
            },
            {
                pName: "服务案例",
                textList: [
                    <div>
                        <img src="img/gansu.png" style={{width: "100%", marginTop: "30px"}}/>

                        <p className="textLine2">甘肃省生态环境遥感监测系统</p>

                        <img src="img/QHSJY.png" style={{width: "100%"}}/>

                        <p className="textLine2">青海三江源生态监测预警平台</p>

                        <img src="img/discharge.png" style={{width: "100%"}}/>

                        <img src="img/discharge2.png" style={{width: "70%", marginLeft: "100px"}}/>
                    </div>
                ]
            }
        ],
    },
};
